//src/command/utils/sembols.js
import { Rectangle, Line, Text } from "./utils";
import { PROJABZE_BRAND_OLE_HEX } from "./projabzeBrandOle";

// ✅ Redux store'u import et
import { store } from '../../../redux/store';
import { COMPONENT_KINDS } from '../../../types/SimpleSupplyPoint';
import { resolveVariablePath } from '../../../config/baslikConfig/variableCatalog';

// Varsayılan başlığın DEĞER hücrelerini (placeholder metinli MTEXT'ler) aktif
// paftanın başlık verisine bağlar. Handle → baslik değişken yolu. Böylece Başlık
// panelinden bir alan değişince (rebuild sonrası) varsayılan başlıkta da güncellenir
// — tıpkı özel şablon binding'lerinde olduğu gibi. resolveVariablePath boş alanda
// proje metadata'sına düşer (autofill ile aynı). Belirsiz/etiket hücreleri (müellif
// bloğu EMO/ONAY/BELEDİYE/YAPI DENETİM, B.T.No, talep faktörü mes/iy/as alt-hücreleri)
// ve güç hücreleri (installed/demandPower dinamik) KASITLI olarak dışarıda.
const BASLIK_VALUE_CELL_PATHS = {
  // Proje Sorumlusu satırı
  '3BC': 'baslik.projeSorumlusu.adiSoyadi',
  '3BD': 'baslik.projeSorumlusu.odaNo',
  '3BE': 'baslik.projeSorumlusu.diplomaNo',
  '3C0': 'baslik.projeSorumlusu.vergiDairesi',
  '3C1': 'baslik.projeSorumlusu.vergiSicilNo',
  // Projeyi Yaptıran
  '3E0': 'baslik.projeyiYaptiran.adiSoyadi',
  '3E1': 'baslik.projeyiYaptiran.adres',
  '3E2': 'baslik.projeyiYaptiran.vergiDairesiNo',
  // Arsa — Yapı Sahibi
  '3E3': 'baslik.arsaOzellikleri.yapiSahibiAdi',
  '3E4': 'baslik.arsaOzellikleri.adres',
  '3E5': 'baslik.arsaOzellikleri.vergiNo',
  // Arsa — konum
  '3DF': 'baslik.arsaOzellikleri.il',
  '3DE': 'baslik.arsaOzellikleri.ilce',
  '3D8': 'baslik.arsaOzellikleri.pafta',
  '3D9': 'baslik.arsaOzellikleri.ada',
  '3DA': 'baslik.arsaOzellikleri.parsel',
  // Yapının Özellikleri
  '3D3': 'baslik.yapiOzellikleri.toplamKat',
  '3D6': 'baslik.yapiOzellikleri.yapiSinifi',
  '3F0': 'baslik.yapiOzellikleri.yapimSuresi',
  '3D5': 'baslik.yapiOzellikleri.toplamAlan',
  '3C6': 'baslik.yapiOzellikleri.kullanimAmaci',
  '3F1': 'baslik.yapiOzellikleri.eskiGuc',
  '3F2': 'baslik.yapiOzellikleri.eklenenGuc',
  '3C8': 'baslik.yapiOzellikleri.cizen',
  '3D4': 'baslik.yapiOzellikleri.cizimTarihi',
  '3C7': 'baslik.yapiOzellikleri.olcek',
  '3D2': 'baslik.yapiOzellikleri.projeNo',
  '3CA': 'baslik.yapiOzellikleri.bagimsizBolSayisi',
};

const layers = {
  0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
  kirmizi: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
  yesil: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65280 },
  mavi: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 255 },
  sari: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16776960 },
  magenta: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16711935 },
  cyan: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65535 },
  gray: { name: 'test', frozen: false, visible: true, colorIndex: 8, color: 12632256 },
  AKSYAZI: { name: 'AKSYAZI', frozen: false, visible: true, colorIndex: 9, color: 12632256 }
};
const kirmizi = layers.kirmizi
const mavi = layers.mavi
const yesil = layers.yesil
const gray = layers.gray

const op_gray = {
  color: gray.color,
  colorIndex: gray.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const op_yesil = {
  color: yesil.color,
  colorIndex: yesil.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const Scl = 1// 0.75
const rowHeight = 50 * Scl
 

export const createBaslik =( ) => {
  // ✅ Redux'tan mainPanel verilerini al
  const state = store.getState();
  const mainPanel = state.simpleSupply.components.find(c =>
    c.kind === COMPONENT_KINDS.DIST_PANEL || c.kind === COMPONENT_KINDS.METER_PANEL
  );

  const installedPower = mainPanel?.electrical?.installedPower || 0;
  const demandPower = mainPanel?.electrical?.demandPower || 0;

 const result=[
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 899.9999999999944,
        "y": 0
      },
      {
        "x": 899.9999999999944,
        "y": 1433.583905267522
      },
      {
        "x": 0,
        "y": 1433.583905267522
      }
    ],
    "handle": "362",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 14.99999999999636,
        "y": 1138.583905267529
      },
      {
        "x": 884.9999999999947,
        "y": 1138.583905267529
      },
      {
        "x": 884.9999999999947,
        "y": 1418.583905267529
      },
      {
        "x": 14.99999999999636,
        "y": 1418.583905267529
      }
    ],
    "handle": "363",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 14.99999999999636,
        "y": 1033.583905267522
      },
      {
        "x": 884.9999999999947,
        "y": 1033.583905267522
      },
      {
        "x": 884.9999999999947,
        "y": 1123.583905267529
      },
      {
        "x": 14.99999999999636,
        "y": 1123.583905267529
      }
    ],
    "handle": "364",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 14.99999999999636,
        "y": 509.999999999999
      },
      {
        "x": 884.9999999999947,
        "y": 509.999999999999
      },
      {
        "x": 884.9999999999947,
        "y": 1018.58390526754
      },
      {
        "x": 14.99999999999636,
        "y": 1018.58390526754
      }
    ],
    "handle": "365",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 15.00000000012187,
        "y": 375
      },
      {
        "x": 885.0000000001164,
        "y": 375
      },
      {
        "x": 885.0000000001164,
        "y": 495
      },
      {
        "x": 15.00000000012187,
        "y": 495
      }
    ],
    "handle": "366",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 15.00000000012187,
        "y": 180
      },
      {
        "x": 885.0000000001164,
        "y": 180
      },
      {
        "x": 885.0000000001164,
        "y": 360
      },
      {
        "x": 15.00000000012187,
        "y": 360
      }
    ],
    "handle": "367",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 405,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 405,
        "z": 0
      }
    ],
    "handle": "368",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 434.9999999999927,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 434.9999999999927,
        "z": 0
      }
    ],
    "handle": "369",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 464.999999999999,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 464.999999999999,
        "z": 0
      }
    ],
    "handle": "36A",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 495,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 495,
        "z": 0
      }
    ],
    "handle": "36B",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 329.9999999999927,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 329.9999999999927,
        "z": 0
      }
    ],
    "handle": "36C",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 299.9999999999991,
        "z": 0
      },
      {
        "x": 106.4553557153504,
        "y": 299.9999999999991,
        "z": 0
      }
    ],
    "handle": "36D",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 270,
        "z": 0
      },
      {
        "x": 106.4553557153504,
        "y": 270,
        "z": 0
      }
    ],
    "handle": "36E",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 240,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 240,
        "z": 0
      }
    ],
    "handle": "36F",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 209.9999999999927,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 209.9999999999927,
        "z": 0
      }
    ],
    "handle": "370",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 884.9999999999947,
        "y": 1093.583905267529,
        "z": 0
      },
      {
        "x": 114.9999999999963,
        "y": 1093.583905267529,
        "z": 0
      }
    ],
    "handle": "371",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 884.9999999999947,
        "y": 988.5839052675292,
        "z": 0
      },
      {
        "x": 14.99999999999636,
        "y": 988.5839052675292,
        "z": 0
      }
    ],
    "handle": "372",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 449.9999999999945,
        "y": 988.5839052675292,
        "z": 0
      },
      {
        "x": 449.9999999999945,
        "y": 509.999999999999,
        "z": 0
      }
    ],
    "handle": "373",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 14.99999999999636,
        "y": 749.2919526337791,
        "z": 0
      },
      {
        "x": 884.9999999999947,
        "y": 749.2919526337791,
        "z": 0
      }
    ],
    "handle": "374",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 15.00000000012187,
        "y": 14.99999999999909
      },
      {
        "x": 885.0000000001164,
        "y": 14.99999999999909
      },
      {
        "x": 885.0000000001164,
        "y": 165
      },
      {
        "x": 15.00000000012187,
        "y": 165
      }
    ],
    "handle": "375",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 134.9999999999991,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "376",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 726.8181818181147,
        "y": 105,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 105,
        "z": 0
      }
    ],
    "handle": "377",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 726.8181818181147,
        "y": 75,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 75,
        "z": 0
      }
    ],
    "handle": "378",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 726.8181818181147,
        "y": 44.99999999999909,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 44.99999999999909,
        "z": 0
      }
    ],
    "handle": "379",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 885.0000000001164,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 15.00000000012187,
        "y": 14.99999999999909,
        "z": 0
      }
    ],
    "handle": "37A",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "MTEXT",
    "handle": "37B",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 348.2555243883853,
      "y": 489.6805242928713,
      "z": 0
    },
    "height": 18,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;PROJEYi YAPTIRAN}",
    "extendedData": {
      "applicationName": "ACAD",
      "customStrings": [
        "AnnotativeData",
        "ACAD_MTEXT_COLUMN_INFO_BEGIN",
        "ACAD_MTEXT_COLUMN_INFO_END"
      ]
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 15.00000000012187,
        "y": 495,
        "z": 0
      },
      {
        "x": 215.0000000001164,
        "y": 495,
        "z": 0
      }
    ],
    "handle": "380",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 196.3311097632377,
        "y": 464.9999999999988,
        "z": 0
      },
      {
        "x": 196.3311097632377,
        "y": 374.9999999999998,
        "z": 0
      }
    ],
    "handle": "381",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 196.3311097632377,
        "y": 329.9999999999927,
        "z": 0
      },
      {
        "x": 196.3311097632377,
        "y": 180,
        "z": 0
      }
    ],
    "handle": "382",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 106.4553557153504,
        "y": 329.9999999999927,
        "z": 0
      },
      {
        "x": 106.4553557153504,
        "y": 180,
        "z": 0
      }
    ],
    "handle": "383",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "MTEXT",
    "handle": "384",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 316.5604046663448,
      "y": 357.2556495983126,
      "z": 0
    },
    "height": 18,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;ARSANIN ÖZELLİKLERİ}"
  },
  {
    "type": "MTEXT",
    "handle": "385",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 316.5604046663448,
      "y": 162.2556495978533,
      "z": 0
    },
    "height": 18,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;YAPININ ÖZELLİKLERİ}"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 578.9502352703057,
        "y": 240.3588180099614,
        "z": 0
      },
      {
        "x": 578.9502352703057,
        "y": 180.3588180099623,
        "z": 0
      }
    ],
    "handle": "386",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 691.6666666667443,
        "y": 240,
        "z": 0
      },
      {
        "x": 691.6666666667443,
        "y": 180,
        "z": 0
      }
    ],
    "handle": "387",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 788.3333333333649,
        "y": 240.3588180099614,
        "z": 0
      },
      {
        "x": 788.3333333333649,
        "y": 180,
        "z": 0
      }
    ],
    "handle": "388",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.1818181818762,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 173.1818181818762,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "389",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 252.2727272728153,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 252.2727272728153,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "38A",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 331.3636363637652,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 331.3636363637652,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "38B",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 410.454545454706,
        "y": 75,
        "z": 0
      },
      {
        "x": 410.454545454706,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "38C",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 476.6492961718249,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 476.6492961718249,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "38D",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 562.5823839472159,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 562.5823839472159,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "38E",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 652.5823839472159,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 652.5823839472159,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "38F",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 726.8181818181147,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 726.8181818181147,
        "y": 134.9999999999991,
        "z": 0
      }
    ],
    "handle": "390",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "MTEXT",
    "handle": "392",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 20.00000000012187,
      "y": 451.732605729714,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adı Soyadı}"
  },
  {
    "type": "MTEXT",
    "handle": "393",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 20.00000000012187,
      "y": 421.7326057297141,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adresi}"
  },
  {
    "type": "MTEXT",
    "handle": "394",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 20.00000000012187,
      "y": 391.7326057297186,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Vergi Dairesi / No}"
  },
  {
    "type": "MTEXT",
    "handle": "395",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 151.393232739294,
      "y": 314.9999999999959,
      "z": 0
    },
    "height": 12,
    "width": 89.87575404788731,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adı Soyadı}"
  },
  {
    "type": "MTEXT",
    "handle": "396",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 151.393232739294,
      "y": 284.9999999999996,
      "z": 0
    },
    "height": 12,
    "width": 89.87575404788731,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adresi}"
  },
  {
    "type": "MTEXT",
    "handle": "397",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 151.393232739294,
      "y": 255,
      "z": 0
    },
    "height": 12,
    "width": 89.87575404788731,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Vergi D./No}"
  },
  {
    "type": "MTEXT",
    "handle": "398",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 60.72767785773613,
      "y": 284.9999999999964,
      "z": 0
    },
    "height": 12,
    "width": 91.4553557152285,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Yapı Sahibi}"
  },
  {
    "type": "MTEXT",
    "handle": "399",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 151.393232739294,
      "y": 224.9999999999964,
      "z": 0
    },
    "height": 12,
    "width": 89.87575404788731,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;İlçe}"
  },
  {
    "type": "MTEXT",
    "handle": "39A",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 60.72767785773613,
      "y": 224.9999999999964,
      "z": 0
    },
    "height": 12,
    "width": 91.4553557152285,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;İl}"
  },
  {
    "type": "MTEXT",
    "handle": "39B",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 637.8084509685295,
      "y": 224.9999999999964,
      "z": 0
    },
    "height": 12,
    "width": 107.7164313964295,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Pafta}"
  },
  {
    "type": "MTEXT",
    "handle": "39C",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 740.0000000000545,
      "y": 224.9999999999964,
      "z": 0
    },
    "height": 12,
    "width": 96.66666666662066,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Ada}"
  },
  {
    "type": "MTEXT",
    "handle": "39D",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 836.6666666667406,
      "y": 224.9999999999964,
      "z": 0
    },
    "height": 12,
    "width": 96.66666666675162,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Parsel}"
  },
  {
    "type": "MTEXT",
    "handle": "39E",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 173.1818181818762,
      "y": 134.9999999999991,
      "z": 0
    },
    "height": 10,
    "width": 79.09090909093902,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Yapı \\PSınıfı}"
  },
  {
    "type": "MTEXT",
    "handle": "39F",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 252.2727272728153,
      "y": 134.9999999999991,
      "z": 0
    },
    "height": 10,
    "width": 79.09090909094994,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Yapım\\PSüresi}"
  },
  {
    "type": "MTEXT",
    "handle": "3A0",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 15.00000000012187,
      "y": 134.9999999999991,
      "z": 0
    },
    "height": 10,
    "width": 158.1818181817543,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Toplam \\PKat Sayısı}"
  },
  {
    "type": "MTEXT",
    "handle": "3A1",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 476.6492961718249,
      "y": 75,
      "z": 0
    },
    "height": 10,
    "width": 85.93308777539102,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Bağımsız \\PBöl. Sayısı}"
  },
  {
    "type": "MTEXT",
    "handle": "3A2",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 331.3636363637652,
      "y": 134.9999999999991,
      "z": 0
    },
    "height": 10,
    "width": 79.09090909094088,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Toplam \\PAlan (m²)}"
  },
  {
    "type": "MTEXT",
    "handle": "3A3",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 410.454545454706,
      "y": 134.9999999999991,
      "z": 0
    },
    "height": 10,
    "width": 66.19614378757984,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Kullanım\\PAmacı}"
  },
  {
    "type": "MTEXT",
    "handle": "3A4",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 476.6492961718249,
      "y": 134.9999999999991,
      "z": 0
    },
    "height": 10,
    "width": 85.93308777539102,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Eski Toplam\\PGüç (W)}"
  },
  {
    "type": "MTEXT",
    "handle": "3A5",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 562.5823839472159,
      "y": 134.9999999999991,
      "z": 0
    },
    "height": 10,
    "width": 90.00000000000006,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Eklenen\\PGüç (W)}"
  },
  {
    "type": "MTEXT",
    "handle": "3A6",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 652.5823839472159,
      "y": 134.9999999999991,
      "z": 0
    },
    "height": 10,
    "width": 74.2357978708988,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Top. Kurulu\\PGüç (W)}"
  },
  {
    "type": "MTEXT",
    "handle": "3A7",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 94.09090909099905,
      "y": 59.99999999999954,
      "z": 0
    },
    "height": 10,
    "width": 158.1818181817543,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Çizen}"
  },
  {
    "type": "MTEXT",
    "handle": "3A8",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 176.1818181818798,
      "y": 65.99999999999909,
      "z": 0
    },
    "height": 10,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Çizim Tarihi}"
  },
  {
    "type": "MTEXT",
    "handle": "3A9",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 255.2727272728243,
      "y": 65.99999999999909,
      "z": 0
    },
    "height": 10,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Ölçek}"
  },
  {
    "type": "MTEXT",
    "handle": "3AA",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 404.006466267795,
      "y": 59.99999999999909,
      "z": 0
    },
    "height": 10,
    "width": 145.2856598080598,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Proje No}"
  },
  {
    "type": "MTEXT",
    "handle": "3AB",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 569.2514438393954,
      "y": 73.71491330116896,
      "z": 0
    },
    "height": 10,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Talep Fak.(%)}"
  },
  {
    "type": "MTEXT",
    "handle": "3AC",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 689.7002828826653,
      "y": 59.99999999999954,
      "z": 0
    },
    "height": 10,
    "width": 74.2357978708988,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Talep\\PGüç (W)}"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 114.9999999999963,
        "y": 1033.583905267522,
        "z": 0
      },
      {
        "x": 114.9999999999963,
        "y": 1123.583905267529,
        "z": 0
      }
    ],
    "handle": "3AD",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 218.7827478834715,
        "y": 1034.663905864126,
        "z": 0
      },
      {
        "x": 218.7827478834715,
        "y": 1124.663905864112,
        "z": 0
      }
    ],
    "handle": "3AE",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 314.9999999999945,
        "y": 1033.583905267522,
        "z": 0
      },
      {
        "x": 314.9999999999945,
        "y": 1123.583905267529,
        "z": 0
      }
    ],
    "handle": "3AF",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 414.9999999999945,
        "y": 1033.583905267522,
        "z": 0
      },
      {
        "x": 414.9999999999945,
        "y": 1123.583905267529,
        "z": 0
      }
    ],
    "handle": "3B0",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.2815168319448,
        "y": 1033.583905267522,
        "z": 0
      },
      {
        "x": 542.2815168319448,
        "y": 1123.583905267529,
        "z": 0
      }
    ],
    "handle": "3B1",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 614.9999999999945,
        "y": 1033.583905267522,
        "z": 0
      },
      {
        "x": 614.9999999999945,
        "y": 1123.583905267529,
        "z": 0
      }
    ],
    "handle": "3B2",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 714.9999999999945,
        "y": 1033.583905267522,
        "z": 0
      },
      {
        "x": 714.9999999999945,
        "y": 1123.583905267529,
        "z": 0
      }
    ],
    "handle": "3B3",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "MTEXT",
    "handle": "3B4",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 119.9999999999963,
      "y": 1110.316510997261,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adı Soyad\\fArial|b0|i0|c162|p34;ı}"
  },
  {
    "type": "MTEXT",
    "handle": "3B5",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 223.782747883577,
      "y": 1111.396511593829,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Oda No}"
  },
  {
    "type": "MTEXT",
    "handle": "3B6",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 319.9999999999945,
      "y": 1110.316510997261,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Diploma No}"
  },
  {
    "type": "MTEXT",
    "handle": "3B7",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 419.9999999999945,
      "y": 1110.316510997261,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;B.T. No}"
  },
  {
    "type": "MTEXT",
    "handle": "3B8",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 549.1002846206555,
      "y": 1110.316510997261,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Vergi D.}"
  },
  {
    "type": "MTEXT",
    "handle": "3B9",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 619.9999999999945,
      "y": 1110.316510997261,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Vergi No}"
  },
  {
    "type": "MTEXT",
    "handle": "3BA",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 719.9999999999945,
      "y": 1111.316510997261,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Sorumluluk İmzası}"
  },
  {
    "type": "MTEXT",
    "handle": "3BB",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 20,
      "y": 1096.380589516378,
      "z": 0
    },
    "height": 10,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;PROJE \\PSORUMLUSU}"
  },
  {
    "type": "MTEXT",
    "handle": "3BC",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 117.9192450925366,
      "y": 1073.016525393351,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;ads--------}"
  },
  {
    "type": "MTEXT",
    "handle": "3BD",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 223.863555644637,
      "y": 1071.396511593843,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;OdN----------}"
  },
  {
    "type": "MTEXT",
    "handle": "3BE",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 337.9479358389344,
      "y": 1070.316510997243,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;DipNo-}"
  },
  {
    "type": "MTEXT",
    "handle": "3BF",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 418.9999999999945,
      "y": 1070.316510997243,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;BTNO-----}"
  },
  {
    "type": "MTEXT",
    "handle": "3C0",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 554.1627870446573,
      "y": 1070.316510997243,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;VD---}"
  },
  {
    "type": "MTEXT",
    "handle": "3C1",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 618.9999999999945,
      "y": 1070.316510997243,
      "z": 0
    },
    "height": 12,
    "width": 299.3531842503508,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;VNO--------}"
  },
  {
    "type": "MTEXT",
    "handle": "3C2",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 18.99999999999636,
      "y": 984.5839052675291,
      "z": 0
    },
    "height": 10,
    "width": 538.3785886077994,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;EMO}"
  },
  {
    "type": "MTEXT",
    "handle": "3C3",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 453.9999999999945,
      "y": 984.5839052675291,
      "z": 0
    },
    "height": 10,
    "width": 538.3785886077994,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;ONAY YAPACAK KURUM}"
  },
  {
    "type": "MTEXT",
    "handle": "3C4",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 22.40995482960898,
      "y": 745.2919526337608,
      "z": 0
    },
    "height": 10,
    "width": 538.3785886077994,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;BELEDİYE}"
  },
  {
    "type": "MTEXT",
    "handle": "3C5",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 457.4099548296072,
      "y": 745.2919526337608,
      "z": 0
    },
    "height": 10,
    "width": 538.3785886077994,
    "attachmentPoint": 1,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;YAPI DENETİM ŞİRKETİ}"
  },
  {
    "type": "MTEXT",
    "handle": "3C6",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 443.5519208132655,
      "y": 89.99999999999932,
      "z": 0
    },
    "height": 10,
    "width": 66.194750717119,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;MESKEN}"
  },
  {
    "type": "MTEXT",
    "handle": "3C7",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 291.8181818182902,
      "y": 29.99999999999909,
      "z": 0
    },
    "height": 10,
    "width": 79.09090909094999,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;1/50}"
  },
  {
    "type": "MTEXT",
    "handle": "3C8",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 94.09090909099905,
      "y": 29.99999999999909,
      "z": 0
    },
    "height": 12,
    "width": 158.1818181817543,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Çizen- - - -}"
  },
  {
    "type": "MTEXT",
    "handle": "3CA",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 519.6158400595205,
      "y": 29.99999999999909,
      "z": 0
    },
    "height": 10,
    "width": 85.93308777539102,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;1}"
  },
  {
    "type": "MTEXT",
    "handle": "3CB",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 640.1057451412198,
      "y": 52.29488103813039,
      "z": 0
    },
    "height": 7,
    "width": 24.95327761199229,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Asnsr}"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 562.5823839472159,
        "y": 59.58976207626169,
        "z": 0
      },
      {
        "x": 652.5823839472159,
        "y": 59.58976207626169,
        "z": 0
      }
    ],
    "handle": "3CD",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "MTEXT",
    "handle": "3CE",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 580.0823839472159,
      "y": 52.29488103813039,
      "z": 0
    },
    "height": 7,
    "width": 35.00000000000006,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;mesken}"
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 14.99999999999636,
        "y": 1138.583905267529
      },
      {
        "x": 884.9999999998853,
        "y": 1138.583905267529
      },
      {
        "x": 884.9999999998853,
        "y": 1418.583905267529
      },
      {
        "x": 14.99999999999636,
        "y": 1418.583905267529
      }
    ],
    "handle": "3CF",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "MTEXT",
    "handle": "3D1",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 612.6057451412198,
      "y": 52.29488103813039,
      "z": 0
    },
    "height": 7,
    "width": 30.04672238800782,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;iş yeri}"
  },
  {
    "type": "MTEXT",
    "handle": "3D2",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 404.006466267795,
      "y": 29.99999999999909,
      "z": 0
    },
    "height": 10,
    "width": 145.2856598080598,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;379-E}"
  },
  {
    "type": "MTEXT",
    "handle": "3D3",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 94.09090909099905,
      "y": 90,
      "z": 0
    },
    "height": 10,
    "width": 158.1818181817543,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;ZK}"
  },
  {
    "type": "MTEXT",
    "handle": "3D4",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 212.7272727273457,
      "y": 29.99999999999909,
      "z": 0
    },
    "height": 10,
    "width": 79.09090909093902,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;08.06.2022}"
  },
  {
    "type": "MTEXT",
    "handle": "3D5",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 370.9090909092356,
      "y": 90,
      "z": 0
    },
    "height": 10,
    "width": 79.09090909094088,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;50}"
  },
  {
    "type": "MTEXT",
    "handle": "3D6",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 212.7272727273457,
      "y": 90,
      "z": 0
    },
    "height": 10,
    "width": 79.09090909093902,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;3A}"
  },
  {
    "type": "MTEXT",
    "handle": "3D7",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 449.9999999999945,
      "y": 1003.583905267533,
      "z": 0
    },
    "height": 12,
    "width": 870.0000000000009,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;ELEKTRİK İÇ TESİSAT UYGULAMA PROJESİ}"
  },
  {
    "type": "MTEXT",
    "handle": "3D8",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 637.8084509685295,
      "y": 194.9999999999891,
      "z": 0
    },
    "height": 12,
    "width": 107.7164313964295,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;PaftaX}"
  },
  {
    "type": "MTEXT",
    "handle": "3D9",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 740.0000000000545,
      "y": 194.9999999999891,
      "z": 0
    },
    "height": 12,
    "width": 96.66666666662066,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Ada X}"
  },
  {
    "type": "MTEXT",
    "handle": "3DA",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 836.6666666667406,
      "y": 194.9999999999891,
      "z": 0
    },
    "height": 12,
    "width": 96.66666666675162,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Parsel X}"
  },
  {
    "type": "MTEXT",
    "handle": "3DE",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 151.393232739294,
      "y": 195.0000000000036,
      "z": 0
    },
    "height": 12,
    "width": 89.87575404788731,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;İlçe X}"
  },
  {
    "type": "MTEXT",
    "handle": "3DF",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 60.72767785773613,
      "y": 195.0000000000036,
      "z": 0
    },
    "height": 12,
    "width": 91.4553557152285,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;İl X}"
  },
  {
    "type": "MTEXT",
    "handle": "3E0",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 206.3311097632377,
      "y": 299.9999999999991,
      "z": 0
    },
    "height": 12,
    "width": 688.6688902368787,
    "attachmentPoint": 7,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adı Soyadı X}"
  },
  {
    "type": "MTEXT",
    "handle": "3E1",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 206.3311097632377,
      "y": 270,
      "z": 0
    },
    "height": 12,
    "width": 688.6688902368787,
    "attachmentPoint": 7,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adresi X}"
  },
  {
    "type": "MTEXT",
    "handle": "3E2",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 206.3311097632377,
      "y": 240,
      "z": 0
    },
    "height": 12,
    "width": 688.6688902368787,
    "attachmentPoint": 7,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Vergi D./No X}"
  },
  {
    "type": "MTEXT",
    "handle": "3E3",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 206.3311097632377,
      "y": 435.0000000000054,
      "z": 0
    },
    "height": 12,
    "width": 688.6688902368787,
    "attachmentPoint": 7,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adı Soyadı A}"
  },
  {
    "type": "MTEXT",
    "handle": "3E4",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 206.3311097632377,
      "y": 405.0000000000063,
      "z": 0
    },
    "height": 12,
    "width": 688.6688902368787,
    "attachmentPoint": 7,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Adresi A}"
  },
  {
    "type": "MTEXT",
    "handle": "3E5",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 206.3311097632377,
      "y": 375.0000000000064,
      "z": 0
    },
    "height": 12,
    "width": 688.6688902368787,
    "attachmentPoint": 7,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Vergi D./No A}"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 652.5823839472159,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 627.5823839472159,
        "y": 14.99999999999909,
        "z": 0
      }
    ],
    "handle": "3EC",
    "ownerHandle": "1F",
    "layer": "0"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 627.5823839472159,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 627.5823839472159,
        "y": 59.58976207626169,
        "z": 0
      }
    ],
    "handle": "3ED",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 597.5823839472159,
        "y": 14.99999999999909,
        "z": 0
      },
      {
        "x": 597.5823839472159,
        "y": 59.58976207626169,
        "z": 0
      }
    ],
    "handle": "3EE",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik"
  },
  {
    "type": "MTEXT",
    "handle": "3F0",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 291.8181818182848,
      "y": 90,
      "z": 0
    },
    "height": 10,
    "width": 79.09090909093902,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;21Ay}"
  },
  {
    "type": "MTEXT",
    "handle": "3F1",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 519.6158400595205,
      "y": 89.99999999999932,
      "z": 0
    },
    "height": 10,
    "width": 85.93308777539102,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;EsTopGüç}"
  },
  {
    "type": "MTEXT",
    "handle": "3F2",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 607.5823839472159,
      "y": 89.99999999999976,
      "z": 0
    },
    "height": 10,
    "width": 90.00000000000006,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;Ekl Güç}"
  },
  {
    "type": "MTEXT",
    "handle": "3F3",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 689.7002828826653,
      "y": 89.99999999999976,
      "z": 0
    },
    "height": 10,
    "width": 74.2357978708988,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": `{\\fTimes New Roman|b0|i0|c162|p18; ${installedPower.toFixed(2)} kW}`
  },
  {
    "type": "MTEXT",
    "handle": "3F4",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 689.7002828826653,
      "y": 30.32924777697644,
      "z": 0
    },
    "height": 10,
    "width": 74.2357978708988,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": `{\\fTimes New Roman|b0|i0|c162|p18; ${demandPower.toFixed(2)} kW}`
  },
  {
    "type": "MTEXT",
    "handle": "3F5",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 580.0823839472159,
      "y": 29.99999999999909,
      "z": 0
    },
    "height": 7,
    "width": 35.00000000000006,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;mesTF}"
  },
  {
    "type": "MTEXT",
    "handle": "3F6",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 612.6057451412198,
      "y": 29.99999999999909,
      "z": 0
    },
    "height": 7,
    "width": 30.04672238800782,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;iyTF}"
  },
  {
    "type": "MTEXT",
    "handle": "3F7",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 640.0823839472159,
      "y": 29.99999999999909,
      "z": 0
    },
    "height": 7,
    "width": 25.00000000000006,
    "attachmentPoint": 5,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;asTF}"
  },
  {
    "type": "MTEXT",
    "handle": "41D",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 726.8181818181147,
      "y": 74.99999999999909,
      "z": 0
    },
    "height": 50,
    "width": 158.1818181820018,
    "attachmentPoint": 4,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;E}"
  },
  {
    "type": "MTEXT",
    "handle": "448",
    "ownerHandle": "1F",
    "layer": "Doc_Baslik",
    "position": {
      "x": 768.0704436628494,
      "y": 74.99999999999909,
      "z": 0
    },
    "height": 20,
    "width": 116.9295563372671,
    "attachmentPoint": 4,
    "drawingDirection": 5,
    "text": "{\\fTimes New Roman|b0|i0|c162|p18;lektrik}"
  }
]

// ─── Değer hücrelerini aktif paftanın başlık verisiyle doldur ───────────
// Placeholder metinli MTEXT'lerin içeriğini (`{...;CONTENT}`) baslik değerleriyle
// değiştir. Boşsa hücre boş kalır (placeholder değil). Stil prefix'i korunur.
for (const e of result) {
  const path = e && e.handle ? BASLIK_VALUE_CELL_PATHS[e.handle] : null;
  if (!path || typeof e.text !== 'string') continue;
  const val = resolveVariablePath(state, path) || '';
  e.text = e.text.replace(/;[^}]*}/, `;${val}}`);
}

// ─── Projabze marka alanı (üst hücre: x 15-885, y 1138-1418) ───────────
// Marka OLE2FRAME olarak gömülür (native değil): dxfDrawCore /CONTENTS PNG'yi
// render eder; DXF export'ta OLE binary olduğu gibi (passthrough) kullanılır.
result.push({
  type: "OLE2FRAME",
  handle: "PZOLE",
  ownerHandle: "1F",
  layer: "Doc_Baslik",
  binaryHex: PROJABZE_BRAND_OLE_HEX,
  upperLeft: { x: 15, y: 1418, z: 0 },
  lowerRight: { x: 885, y: 1138, z: 0 },
  itemName: "Paintbrush Picture",
  linkName: "Paintbrush Picture",
  oleVersion: 2,
  oleType: 2,
  plotQuality: 0,
  oleAppGenerated: true, // DXF export'ta iç header köşeleri canlı bounds'a rewrite edilsin
});

return {
  result: parseIfNeeded(result) ,
  width: 1000 * Scl,
  height: 1500 * Scl
};
  }

function parseIfNeeded(data) {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error('JSON parse hatası:', e);
      return null;
    }
  }
  return data;
}
 